import { ReactComponent as BreedOne } from "../icon/home/swiperbottom/检验检查.svg";
import { ReactComponent as BreedTwo } from "../icon/home/swiperbottom/筛选.svg";
import { ReactComponent as BreedThree } from "../icon/home/swiperbottom/关系.svg";
import { ReactComponent as BreedFour } from "../icon/home/swiperbottom/分子身份证.svg";
const BreedingMenuItem = [
  {
    key: "left1",
    label: (
      <a
        href="#/Breeding/breedident/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <BreedOne width={20} style={{ margin: "0 5px" }} />
        Breed Identification
      </a>
    ),
  },
  {
    key: "left2",
    label: (
      <a
        href="#/Breeding/corecollection/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <BreedTwo width={20} style={{ margin: "0 5px" }} />
        Core Collection
      </a>
    ),
  },
  {
    key: "left3",
    label: (
      <a
        href="#/Breeding/kinshipc/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <BreedThree width={27} style={{ margin: "0 1px" }} />
        Kinship Identification
      </a>
    ),
  },
  {
    key: "left4",
    label: (
      <a
        href="#/Breeding/molecular/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <BreedFour width={20} style={{ margin: "0 5px" }} />
        Molecular ID Codes
      </a>
    ),
  },
];
export default BreedingMenuItem;
